// extracted by mini-css-extract-plugin
export default {"name":"ParticipantStreamComponent_name__jTEcb","videoComp":"ParticipantStreamComponent_videoComp__hJlXt"};